import React from 'react';

const Contact: React.FC = () => {
  return (
    <div className="card">
      <div className="card-header">
        <h5 className="mb-0">Contact Us</h5>
      </div>
      <div className="card-body">
        <p className="mb-2">Travancore Devaswom Board</p>
        <p className="mb-2">Sabarimala Devaswom</p>
        <p className="mb-0 text-muted">For queries related to the Kanikka Vanchi system.</p>
      </div>
    </div>
  );
};

export default Contact;
